import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const StyledSelect = styled.select`
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  font-family: inherit;
  color: ${COLORS.textPrimary};
  background-color: ${COLORS.surface};
  border: 1px solid ${COLORS.border};
  border-radius: ${RADII.field};
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${COLORS.borderHover};
  }

  &:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }

  &:disabled {
    background-color: ${COLORS.fill};
    cursor: not-allowed;
  }
`
